import GalleryModal from './GalleryModal';

export default GalleryModal;



// WEBPACK FOOTER //
// ./scripts/blocks/GalleryModal/index.js